import {Deserializable} from "../deserializable.model";

export class Offline implements Deserializable  {
  User_ID!:string;
  Application!:string;
  Client_ID!:string;
  Project_ID!:string;
  Report_Type!:string;
  SelectedReports!:string;
  CreatedDate!:string;
  Remarks!:string;
  downloadFileName!:string;

    deserialize(input: any) {
        Object.assign(this, input);
        return this;
      }
}

export class FileDownloadpath {
  Filepath! : string;
  Filename! : string;
}
